import { clientForm } from "../setup/forms.js";
import { S, ui } from "../../app/store.js";
import { inSite, projectSite, siteName } from "../sites/model.js";
import { sitePicker } from "../sites/components.js";
import { invForm } from "./components.js";
import { chip, csvBtn, panel, seg } from "../../components/ui.js";
import { fmtD } from "../../domain/dates.js";
import { esc, peso } from "../../domain/format.js";
import { canInvoice } from "../../services/access.js";
import { TIN_RE } from "../../domain/reference.js";
import { invoiceParties, invoiceParty } from "../../domain/invoicing.js";

function accInvoices() {
  const f = ui.invf || "all",
    scopedInvoices = S.invoices.filter((i) => inSite(i.project)),
    list = scopedInvoices
      .filter(
        (i) =>
          f === "all" ||
          (f === "unpaid" ? i.status === "UNPAID" : i.status === "PAID"),
      )
      .slice()
      .reverse();
  return `<div class="page-toolbar">${sitePicker()}${clientForm()}</div>${ui.invDraft ? invForm() : ""}
  ${panel(
    "Sales invoices",
    `${scopedInvoices.length} issued in this location scope · Company series SI-000001 to ${S.invoices.at(-1)?.no || "—"}, no gaps`,
    csvBtn("t-inv"),
    `${seg(
      "invf",
      [
        ["all", "All"],
        [
          "unpaid",
          `Unpaid (${scopedInvoices.filter((i) => i.status === "UNPAID").length})`,
        ],
        ["paid", "Paid"],
      ],
      f,
    )}
   <div class="tbl"><table id="t-inv"><thead><tr><th>No.</th><th>Date</th><th>Seller</th><th>Seller TIN</th><th>Seller business address</th><th>Buyer</th><th>Buyer TIN</th><th>Buyer business address</th><th>Project</th><th class="n">Total</th><th class="n">Payable</th><th>Status</th><th></th></tr></thead><tbody>
   ${list.map((i) => `<tr><td class="num" style="text-align:left">${i.no}</td><td>${fmtD(i.date)}</td><td>${esc(invoiceParties(i).seller.name || "Not recorded")}</td><td>${esc(invoiceParties(i).seller.tin || "Not recorded")}</td><td>${esc(invoiceParties(i).seller.address || "Not recorded")}</td><td>${esc(invoiceParties(i).buyer.name || "Not recorded")}</td><td>${esc(invoiceParties(i).buyer.tin || "Not recorded")}</td><td>${esc(invoiceParties(i).buyer.address || "Not recorded")}</td><td>${esc(i.project || "—")}<div class="small muted">${esc(siteName(projectSite(i.project)))}</div></td><td class="n">${peso(i.gross)}</td><td class="n">${peso(i.due)}</td><td>${i.status === "PAID" ? chip("Paid " + fmtD(i.paidOn), "good") : chip("Unpaid", "warn")}</td><td><div class="row" style="flex-wrap:nowrap"><button class="out" data-act="inv-view" data-id="${i.no}">View</button>${i.status === "UNPAID" && canInvoice() ? `<button data-act="inv-pay" data-id="${i.no}">Record payment</button>` : ""}</div></td></tr>`).join("") || `<tr><td colspan="13" class="muted">No invoices in this filter.</td></tr>`}
   </tbody></table></div>`,
  )}
  ${panel("Clients", `TIN and business address are required before a client can be invoiced`, "", `<div class="tbl"><table><thead><tr><th>Client</th><th>TIN</th><th>Business address</th><th>VAT</th><th></th></tr></thead><tbody>${S.clients.map((c) => `<tr><td>${esc(c.name)}</td><td class="num" style="text-align:left">${TIN_RE.test(c.tin) ? esc(c.tin) : chip("Missing", "bad")}</td><td>${invoiceParty(c).address ? esc(invoiceParty(c).address) : chip("Missing", "bad")}</td><td>${c.vat ? chip("VAT-registered", "acc") : chip("Non-VAT", "mut")}</td><td>${canInvoice() ? `<button type="button" class="out" data-client-edit="${esc(c.id)}">Edit Details</button>` : ""}</td></tr>`).join("")}</tbody></table></div>`)}`;
}

export { accInvoices };
